<div class="col-md-6 col-md-offset-3">
  <div class="reset-block">
      <h2>Mail verified successfully....</h2>
      <br/>
      <p> <a [routerLink]="['/all-plans']">Go to your plans
      </a></p>

</div>
</div>
